import IMask from 'imask'

export const pluralizer = (
  number: number,
  one: string,
  couple: string,
  more: string,
  isIncludeNumber?: boolean
): string => {
  const titles = [one, couple, more]
  const cases = [2, 0, 1, 1, 1, 2]

  if (!Number.isInteger(number)) {
    return isIncludeNumber ? `${number} ${more}` : more
  }

  const str = titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]

  return isIncludeNumber ? `${number} ${str}` : str
}

// Сформировать полное имя из 3 отдельных полей ФИО
export const getFullNameFromFio = ({ lastname, firstname, secondname }: TFullName): string =>
  [lastname?.trim(), firstname?.trim(), secondname?.trim()].filter(Boolean).join(' ')

// Сформировать короткое написание полного имени из 3 отдельных полей ФИО
export const getShortNameFromFio = ({ lastname, firstname, secondname }: TFullName): string =>
  [
    lastname ? lastname.trim() : '',
    firstname && firstname.trim().length > 0 ? `${firstname.trim()[0]}.` : '',
    secondname && secondname.trim().length > 0 ? `${secondname.trim()[0]}.` : ''
  ]
    .join(' ')
    .trim()

export const parseMobilePhone = (phoneNumber?: string | number): string => {
  if (!phoneNumber) {
    return ''
  }

  const masked = IMask.createMask({ mask: '00000000000' })
  masked.resolve(String(phoneNumber))

  return masked.value
}

export const formatMobilePhone = (phoneNumber?: string | number): string => {
  if (!phoneNumber) {
    return ''
  }

  const masked = IMask.createMask({ mask: '+# (000) 000 00 00', definitions: { '#': /[7-8]/ } })
  masked.resolve(String(phoneNumber))

  return masked.value
}

export const getFormatPhoneNumber = (phoneNumber: string | undefined): string => {
  if (!phoneNumber) {
    return ''
  }

  const cleaned = phoneNumber.replace(/\D/g, '')
  const regex = /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/
  const match = regex.exec(cleaned)

  return match
    ? `${match[1] !== '7' ? '' : '+'}${match[1]} ${match[2]} ${match[3]} ${match[4]}-${match[5]}`
    : phoneNumber
}

// Сформировать строку с телефоном, содержащую сам телефон и добавочный номер
export const getFormattedPhoneWithPhoneExt = ({
  phoneNumber,
  phoneExt
}: {
  phoneExt?: string
  phoneNumber?: string
}): string => {
  let ext = phoneExt || ''
  ext = ext.trim()

  return !ext ? getFormatPhoneNumber(phoneNumber) : `${getFormatPhoneNumber(phoneNumber)} (доб. ${ext})`
}

// Форматирование цены для отображения в интерфейсе
export const getFormattedPrice = (value?: string | number, isAddZeros?: boolean): undefined | string => {
  if (value || value === 0 || value === '0') {
    let valueFloat
    if (typeof value === 'string') {
      valueFloat = parseFloat(value)
      if (isNaN(valueFloat)) {
        return ''
      }
    } else {
      valueFloat = value
    }

    let str
    if (isAddZeros) {
      str = valueFloat.toFixed(2)
    } else {
      str = (Math.floor(valueFloat * 100) / 100).toString()
    }

    return str.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  return ''
}

// Форматирование цены со знаком рубля для отображения в интерфейсе
export const getFormattedPriceWithRouble = (price?: string | number, isAddZeros = true): string => {
  const formattedPrice = getFormattedPrice(price, isAddZeros)
  if (formattedPrice === '') {
    return '—'
  }

  return `${formattedPrice} ₽`
}

// Удаление повторяющихся пробелов
export const trimMultiSpaces = (string: string) =>
  string
    .split(' ')
    .filter((el) => el !== '')
    .join(' ')

export const escapeRegExp = (string: string) => string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&')
